module.exports = __webpack_public_path__ + "NeueFrutigerWorld-ThinIt.06afa0b97c261b7d5e27.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-ThinIt.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-ThinIt.ttf
// module chunks = styles